/**
 * 群组管理 API 服务
 */
import { api, API_PATHS } from './client';

// 群组信息
export interface GroupData {
  id: string;
  orgId: string;
  name: string;
  description: string;
  memberCount: number;
  createdAt: string;
  updatedAt: string;
}

// 创建群组请求
export interface CreateGroupRequest {
  name: string;
  description?: string;
}

/**
 * 获取群组列表 (Admin)
 */
export async function getGroups(): Promise<GroupData[]> {
  return api.get<GroupData[]>(API_PATHS.GROUPS);
}

/**
 * 获取群组列表 (Creator)
 */
export async function getGroupsForCreator(): Promise<GroupData[]> {
  return api.get<GroupData[]>(API_PATHS.CREATOR_GROUPS);
}

/**
 * 创建群组
 */
export async function createGroup(data: CreateGroupRequest): Promise<GroupData> {
  return api.post<GroupData>(API_PATHS.GROUPS, data);
}

/**
 * 删除群组
 */
export async function deleteGroup(id: string): Promise<void> {
  await api.delete<null>(`${API_PATHS.GROUPS}/${id}`);
}
